module.exports = __webpack_public_path__ + "static/white-mercedes-benz-841802511041b0170bd837d6ae2fde72.jpg";